import ResearchGroupIntro from '../Components/ResearchGroupIntro';

const FinTechIntro = () => {
    return <ResearchGroupIntro route="/finTech" />;
}
export default FinTechIntro;
